import { useState } from 'react';
import { toast } from 'sonner';
import { ExpertsTermsAndAgreement } from '../ExpertsTermsAndAgreement';
import { LawyerTermsContent } from './LawyerTermsContent'; 
import { submitLawyerOnboarding } from '../../../../../api/onboardingApis/lawyerOnboardingApi/lawyerFinalStep.api'; 
import { IS_DEV, TEST_REAL_API } from "@/config/env";

export const LawyerFinalStep = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleLawyerSubmit = async () => {
    setIsSubmitting(true);
    const finalLoadingToast = toast.loading('Finalizing your expert profile submission...');

    try {
      const expertCode = localStorage.getItem('expertCode');
      
      if (!expertCode) {
        toast.error("Session expired. Please login again.", { id: finalLoadingToast });
        throw new Error("Missing expertCode");
      }

      if (IS_DEV && !TEST_REAL_API) {
        await new Promise(resolve => setTimeout(resolve, 1500));
        toast.success("⚡ Mock Submission Successful!", { id: finalLoadingToast });
        return; 
      }
      
      const payload = {
        expertCode,
        isAgreementSigned: true,
        isAcknowledged: true,
      };

      await submitLawyerOnboarding(payload);
      toast.success("Application submitted successfully! Welcome aboard.", { id: finalLoadingToast });
      
    } catch (error: any) {
      console.error("Submission failed", error);
      
      // 🟢 FIXED: Extracts array strings correctly from NestJS DTO pipes on final step failure
      const serverMessage = error.response?.data?.message;
      const formattedError = Array.isArray(serverMessage) ? serverMessage[0] : serverMessage;

      toast.error(formattedError || "Failed to submit application. Please try again.", { id: finalLoadingToast });
      throw error;
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ExpertsTermsAndAgreement
      roleName="Legal Expert"
      onSubmit={handleLawyerSubmit}
      isSubmitting={isSubmitting}
    >
      <LawyerTermsContent />
    </ExpertsTermsAndAgreement>
  );
};

export default LawyerFinalStep;